import { render } from "./DigitalServiceResults.vue?vue&type=template&id=1486a3f5&ts=true"
import script from "./DigitalServiceResults.vue?vue&type=script&lang=ts"
export * from "./DigitalServiceResults.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/witteveenbos/witteveenbos-light-modules/corporate-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__